/*
 * @Description:: 请补充填写
 * @Version: 1.0
 * @Author: 小白
 * @Date: 2022-04-25 15:58:33
 * @LastEditors: smallWhite
 * @LastEditTime: 2023-03-28 14:50:28
 * @FilePath: /chat_gpt/src/api/api.js
 */
import axios from 'axios'


// export const baseUrl = 'http://47.88.24.100/paper-server'
// export const baseUrl = 'http://47.251.60.159/paper-server'
// export const baseUrl = 'https://paper.bixuange.com/paper-server' //测试环境
// export const baseUrl = 'http://47.106.183.113/paper-server' //测试环境
export const baseUrl = 'https://paperspotlight.com/paper-server' //一个包正式服
// export const baseUrl = 'https://cn.paperspotlight.com/paper-server' //一个包是香港

// const picUrl = 'http://47.106.183.113/paper-case-pic/' 
const picUrl = 'https://paperspotlight.com/paper-case-pic/' //这个blogs页面图片的路径

const iconUrl = 'https://paperspotlight.com/logo/'  //这是blogs页面icon的路径，始终不变
// 用户登录
// export const LOGIN = params => { return axios.post(`${baseUrl}/login`, params).then(res => res.data) }
// // 用户退出
// export const GETVERCODE = params => { return axios.get(`${baseUrl}/verifyCode`) }

//
export const HTTP_URI = {
  BASEURL: baseUrl,
  PICURL:picUrl,
  ICONURL: iconUrl,

  usetRegister: baseUrl +'/user/register',  //用户注册
  sendEmail: baseUrl +'/code/sendEmail',  //发送邮箱验证码
  changePassword: baseUrl +'/user/changePassword',  //修改密码
  forgetPassword: baseUrl +'/user/forgetPassword',  //忘记密码 修改密码
  cancelAccount: baseUrl +'/user/cancelAccount',  //注销

  getAcademicList: baseUrl +'/case/getCaseList',  //获取博客list
  cancelAcademicAccount: baseUrl +'/case/getDetail',  //获取博客详情

  queryJournals: baseUrl +'/journal/queryJournals',  //获取journal
  queryBeacons: baseUrl +'/journal/queryBeacons',  //获取journal




  usetrLogin: baseUrl +'/user/login',  //用户登录
  tempLogin: baseUrl +'/user/tempLogin',  //临时验证码登录

  userlogout: baseUrl +'/user/logout',  //用户登出
  getUserInfo: baseUrl +'/user/getUserInfo',  //获取个人信息
  editUserInfo: baseUrl +'/user/editUserInfo',  //修改个人信息
  getUserScholarDetail: baseUrl +'/user/getScholarDetail',  //获取个人网页信息


  getOrderNumber: baseUrl +'/order/getOrderNumber',  //获取随机数 get

  
  getPayPackage: baseUrl +'/package/getPaymentPackageList',  //获取可选套餐列表

  addArticle: baseUrl +'/article/addArticle',  //新增文章
  editArticle: baseUrl +'/article/editArticle',  //修改文章
  deleteArticle: baseUrl +'/article/deleteArticle',  //删除文章
  getArticleList: baseUrl +'/article/getArticleList',  //获取文章列表
  uploadFile: baseUrl +'/article/uploadFile',  //上传
  editArticleRatio: baseUrl +'/article/editArticleRatio',  //修改比例
  
  getUserPermission: baseUrl +'/user/getUserPermission',  //获取用户权限ge



  addOrder: baseUrl +'/order/addOrder',  //新增订单 -套餐
  getUserPackageList: baseUrl +'/package/getUserPackageList',  //获取用户已经支付的套餐列表
  getArticlesByPackage: baseUrl +'/package/getArticlesByPackage',  //获取套餐已经添加的文章列表
  packageOfAddArticle: baseUrl +'/package/addArticle',  //添加文章到套餐
  packageOfremoveArticle: baseUrl +'/package/removeArticle',  //取消套餐文章
  refundPaymentOrder: baseUrl +'/order/refundPaymentOrder',  //单次购买的套餐退款：?paymentIntent=djfhajsdfas
  cancelSubscription: baseUrl +'/order/cancelSubscription',  //取消订阅
  refundInvoiceOrder: baseUrl +'/order/refundInvoiceOrder',  //订阅套餐单个订单退款?invoiceId=djfhajsdfas
  getOrderList: baseUrl +'/order/getOrderList',  //已经支付的订单列表：
  billingPortal: baseUrl +'/order/billingPortal',  //修改付款方式
  sendInvoiceEmail: baseUrl +'/order/sendInvoiceEmail',  //发送发票?invoiceId=12&paymentIntent=12


  getMessageList: baseUrl +'/message/getMessageList',  //detail
  getMailMessageList: baseUrl +'/message/getMailMessageList',  //detail 1204替换为 分页获取邮件详情列表(手动发送)
  getAutoMessageList: baseUrl +'/message/getAutoMessageList',  //detail  分页获取邮件详情列表(自动发送)
  getMailMessageNoDown: baseUrl +'/message/getMailMessageNoDown',  //获取未下载列表
  getAllAutoMessageList: baseUrl +'/message/getAllAutoMessageList',  //获取自动发送邮件列表

  // updateMailMessageStatus: baseUrl +'/message/updateMailMessageStatus',  //批量修改邮件已读状态
  updateAllMailMessageStatus: baseUrl +'/message/updateAllMailMessageStatus',  //批量修改邮件已读状态
  
  getUserSetting: baseUrl +'/user/getUserSetting',  //用户获取是否自动发送
  editUserSetting: baseUrl +'/user/editUserSetting',  //用户修改是否自动发送
  getMessageStatistic: baseUrl +'/message/getMessageStatistic',  //获取用自动发送和手动发送邮件数
  editUserSettingTransfer: baseUrl +'/user/editUserSettingTransfer',  //获取用户手动发送邮件转为自动发送的数量  // transfer为true代表把手动发送的邮件转为自动发送


  getTemplate: baseUrl +'/message/getTemplate',  //获取模版
  addTemplate: baseUrl +'/message/addTemplate',  //保存模版


  getNecessary: baseUrl +'/user/getNecessary',  //获取需要做的

  getNoticeList: baseUrl +'/notice/getNoticeList',  //用户获取消息列表
  updateNoticeView: baseUrl +'/notice/updateNoticeView',  //?noticeId=1.修改消息已读状态
  updateAllNoticeView: baseUrl +'/notice/updateAllNoticeView',  //?noticeId=1.修改所有消息设为已读状态



  addContact: baseUrl +'/user/addContact',  //邮箱告诉我们
  addStrategy: baseUrl +'/user/addStrategy',  //个人喜好
  getStrategy: baseUrl +'/user/getStrategy',  //获取个人喜好

  unsubscribeEmail: baseUrl +'/code/unsubscribeEmail',  //退订接口

  savaPackageServerLevel: baseUrl +'/package/savaPackageServerLevel',  //订购套餐时保存用户各服务的比重值
  savaDefaultServerLevel: baseUrl +'/package/savaDefaultServerLevel',  //保存用户默认的比重值





 


  

  // http://127.0.0.1:8811/order/cancelSubscription?userPackageId=djfhajsdfas 取消订阅







  UPLOAD: baseUrl +'/upload/uploadFile',
  ADDITEM: baseUrl +'/project/addProjectInfo',//新增项目数据
  EDITITEM: baseUrl +'/project/editEnterpriseInfo',//修改项目信息
  GETITEM: baseUrl +'/project/getAllProjectInfo',//获取所有项目列表
  DElITEM: baseUrl +'/project/deleteProjectById',//删除项目

  EDITPROJECT:baseUrl +'/project/editProjectInfo',  //修改项目信息
  GETDETIAL: baseUrl +'/project/getProjectById',//根据项目Id获取项目详情
  GETVERCODE: baseUrl + '/code/getVerify', //获取图片验证码
  EMAILCODE: baseUrl + '/code/sendEmail', //发送邮件验证码
  LOGIN: baseUrl + '/user/login', //用户登录
  REGISTER: baseUrl + '/user/register', //用户注册
  FORGETWORD: baseUrl + '/user/forgetPassword', //忘记密码
  LOGOUT: baseUrl + '/user/logout', //退出

  GETALLUSER: baseUrl + '/user/getAllUser', //获取所有用户列表
  CHANGEROLE: baseUrl + '/user/changeUserRole', //修改用户权限

  //dashboards模块
  GETCITION: baseUrl + '/statistics/getCitationStatistics', //Citation数量展示和图表 day取值为7、30、90
  GETSERVERCHART: baseUrl + '/statistics/getServerChart', //dashboards模块几个服务折线图
  GETSERVERSTATISTICS: baseUrl + '/statistics/getServerStatistics', //dashboards模块服务数量全部汇总

  // GETUSERPACKAGELISt: baseUrl + '/package/getUserPackageList', //用户获取已经存在的套餐和套餐对应的服务
  editPackageService: baseUrl + '/package/editPackageService', //用户修改对应服务的优先级

  getMailSetting: baseUrl + '/user/getMailSetting', //用户获取邮件发送设置
  setMailSetting: baseUrl + '/user/setMailSetting', //用户设置提醒邮件发送间隔

  potentialEmail: baseUrl + '/code/potentialEmail', //引导页获取用户邮箱等信息






  GETALLUSERLIST : baseUrl + '/manage/getUserRoom', //查询用户聊天列表
  GETONELIST : baseUrl + '/manage/getUserRoomById', //根据id查询用户聊天具体内容
  GETCODELIST : baseUrl + '/manage/getInviteCode', //查询邀请码列表"
  CREATECODE : baseUrl + '/manage/saveInviteCode', //生成邀请码"
  CODENOTES : baseUrl + '/manage/saveInviteCodeNotes', //邀请码备注

  DELCHAT: baseUrl + '/chatUser/deleteUserChat', //删除用户聊天记录
  GETUSERLIST: baseUrl +'/chatUser/getUserChatList',//获取用户聊天记录
  PRODUCT: baseUrl + '/product/list',
  USERHOME: baseUrl + '/user/token/home',
  CHAT: baseUrl + '/v1/chat/turbo',
  getType: baseUrl + '/user/token/getType',
  REPEST: baseUrl + '/use/log/updateLog',
  ADD: baseUrl + '/use/log/resetLog',
  NOTICELIST: baseUrl + '/announcement/queryPage',
  PAY: baseUrl + '/order/create',

  getMailStatistic: baseUrl + '/statistics/getMailStatistic', // dashboard模块Researchers统计

}
// export default { HTTP_URI, baseUrl }
